module.exports = __webpack_public_path__ + "static/media/icon-chapter.e8c20d80.svg";